export default function PHP_set_exception_handler() {
  return (
    <div>
      <h1>PHP_set_exception_handler</h1>
    </div>
  );
}
